import StoryGenerator from './components/StoryGenerator';
import './App.css';

function App() {
  return (
    <div className="App">
      <StoryGenerator />
    </div>
  );
}

export default App;
